/**
 * Local DateTime Converter
 * Converts UTC dates to browser's local timezone
 */

(function() {
    'use strict';

    /**
     * Format a date according to the specified format string
     * @param {Date} date - JavaScript Date object
     * @param {string} format - Format string (e.g., "MMM dd, yyyy HH:mm")
     * @param {boolean} showTimezone - Whether to append timezone abbreviation
     * @returns {string} Formatted date string
     */
    function formatDate(date, format, showTimezone) {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        const pad = (num, size = 2) => String(num).padStart(size, '0');

        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();

        // 12-hour format
        const hours12 = hours % 12 || 12;
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const ampmLower = ampm.toLowerCase();

        // Replacements map
        const replacements = {
            'yyyy': year,
            'yy': String(year).slice(-2),
            'MMMM': monthsFull[month],
            'MMM': months[month],
            'MM': pad(month + 1),
            'M': month + 1,
            'dd': pad(day),
            'd': day,
            'HH': pad(hours),
            'H': hours,
            'hh': pad(hours12),
            'h': hours12,
            'mm': pad(minutes),
            'm': minutes,
            'ss': pad(seconds),
            's': seconds,
            'tt': ampm,
            't': ampmLower
        };

        // Three-pass replacement to handle quoted literals and prevent token corruption
        // Pass 1: Extract and protect quoted strings (e.g., 'at' in "MMM d, yyyy 'at' h:mm")
        const literals = [];
        let result = format.replace(/'([^']*)'/g, (match, content) => {
            const placeholder = `\x00${literals.length}\x00`;
            literals.push(content);
            return placeholder;
        });

        // Pass 2: Replace tokens with unique placeholders (longest first)
        const keys = Object.keys(replacements).sort((a, b) => b.length - a.length);
        const placeholders = [];

        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const placeholder = `{{${i}}}`;
            placeholders.push(replacements[key]);
            result = result.replace(new RegExp(key, 'g'), placeholder);
        }

        // Pass 3a: Replace token placeholders with actual values
        for (let i = 0; i < placeholders.length; i++) {
            const placeholder = `{{${i}}}`;
            result = result.replace(new RegExp(placeholder.replace(/[{}]/g, '\\$&'), 'g'), placeholders[i]);
        }

        // Pass 3b: Restore quoted literal strings
        for (let i = 0; i < literals.length; i++) {
            result = result.replace(`\x00${i}\x00`, literals[i]);
        }

        // Add timezone if requested
        if (showTimezone) {
            const tzAbbr = date.toLocaleTimeString('en-US', { timeZoneName: 'short' }).split(' ').pop();
            result += ' ' + tzAbbr;
        }

        return result;
    }

    /**
     * Convert all UTC datetime elements to local timezone
     */
    function convertAllDates() {
        const elements = document.querySelectorAll('.local-datetime[data-utc]');

        elements.forEach(el => {
            const utcString = el.getAttribute('data-utc');
            const format = el.getAttribute('data-format') || 'MMM dd, yyyy HH:mm';
            const showTimezone = el.getAttribute('data-show-timezone') === 'true';

            try {
                const utcDate = new Date(utcString);

                // Check if date is valid
                if (isNaN(utcDate.getTime())) {
                    console.warn('Invalid date:', utcString);
                    return;
                }

                // Convert to local timezone and format
                const localFormatted = formatDate(utcDate, format, showTimezone);

                el.textContent = localFormatted;
                el.setAttribute('title', `Local time: ${utcDate.toLocaleString()}`);
            } catch (error) {
                console.error('Error converting date:', error, utcString);
            }
        });
    }

    // Run on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', convertAllDates);
    } else {
        convertAllDates();
    }

    // Expose for dynamic content
    window.convertLocalDates = convertAllDates;
})();
